import { z } from 'zod'

import { GridInitialState } from '@mui/x-data-grid-premium'

export type SavedSearchType = {
    name: string
    state: GridInitialState
    queryField?: string
}

export const SearchScopeSchema = z.enum([
    'searchStatesActivity',
    'searchStatesAgreement',
    'searchStatesAsset',
    'searchStatesBundle',
    'searchStatesEdition',
    'searchStatesEditionSalesSheet',
    'searchStatesWork',
    'searchStatesWorkLaunchBrief',
    'searchStatesConcept',
    'searchStatesContact',
])

export type SearchScope = z.infer<typeof SearchScopeSchema>

export const FILTER_ONLY_SCOPES: SearchScope[] = [
    'searchStatesEditionSalesSheet',
    'searchStatesWorkLaunchBrief',
]

export const supportsColumnViews = (scope: SearchScope) => !FILTER_ONLY_SCOPES.includes(scope)

export const columnScopeKey = (scope: SearchScope) => scope.replace(/^searchStates/, 'columnViews')
